import axios from "axios";

import { API_ORIGIN } from "./apiConfig";

const API_BASE_URL = `${API_ORIGIN}/api`;

interface LoginPayload {
    login: string;
    password: string;
}

export const authService = {
    async login(payload: LoginPayload) {
        try {
            const response = await axios.post(`${API_BASE_URL}/auth/login`, payload);
            return response.data;
        } catch (error: any) {
            console.error("Login API error:", error);
            throw error.response?.data || { message: "Login failed" };
        }
    },
};
